import { render, staticRenderFns } from "./HeartFilled.vue?vue&type=template&id=2b30088f&"
import script from "./HeartFilled.vue?vue&type=script&lang=js&"
export * from "./HeartFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports